import authInstance from "../Interceptor";

export const AddProductQuantityEffect = (productQuantityData, config) => {
  return authInstance.post(
    "/product_quantity/add",
    productQuantityData,
    config
  );
};

export const EditProductQuantityEffect = (productQuantityId, updatedData) => {
  return authInstance.put(
    `/product_quantity/update/${productQuantityId}`,
    updatedData
  );
};

export const DeleteProductQuantityEffect = (productQuantityId) => {
  return authInstance.delete(`/product_quantity/delete/${productQuantityId}`);
};

export const ViewProductQuantityEffect = (productQuantityId) => {
  return authInstance.get(`/product_quantity/detail?id=${productQuantityId}`);
};

export const ViewAllProductsQuantityEffect = (payload) => {
  return authInstance.get(
    `/product_quantity/list?pagination_required=true&pagesize=10&pageNo=${payload.pageNo}&search_key=${payload.search_key}`
  );
};

export const ViewAllSearchProductsQuantityEffect = () => {
  return authInstance.get(`/product_quantity/list`);
};
